export const siteConfig = {
  name: "Corehypnose.dk",
  title: "Corehypnose.dk – Metakognitiv terapi & hypnose i Valby",
  description: "Professionel metakognitiv terapi og hypnose i Valby v. Lars Nissen Corell – Psykoterapeut MPF. Speciale i angst, stress, depression og tankemylder.",
  contact: {
    name: "Lars Nissen Corell",
    title: "Psykoterapeut MPF",
    primaryTitle: "Lars Nissen Corell – Psykoterapeut MPF",
    role: "Psykoterapeut MPF · Metakognitiv terapi & hypnose",
    companyName: "Core Hypnose v/Lars Nissen Corell",
    cvr: "41913843",
    titles: [
      "Psykoterapeut MPF",
      "Certificeret metakognitiv psykoterapeut, Neokognitivt Institut, Level IV – højeste niveau",
      "Certificeret metakognitiv supervisor og hypnoterapeut"
    ],
    email: "kontakt@corehypnose.dk",
    phone: "27 20 46 71",
    hours: "Man - Fre: 09:00 - 16:00 | Weekend: Lukket",
    address: "Valby Tingsted 7, 1. sal, 2500 Valby",
    googleMaps: "https://maps.app.goo.gl/..."
  },
  colors: {
    primary: "#123F13", // Grøn
    accent: "#8C2F12",  // Brunrød
    bgCream: "#FAF7F2",
    bgBeige: "#F4EFE7",
    bgSand: "#E8DDCE",
    text: "#3B352F",
    gold: "#B89B5E"
  }
};

export const menuItems = [
  { label: "Forside", path: "/" },
  { 
    label: "Behandlinger", 
    path: "/behandlinger",
    dropdown: [
      { label: "Metakognitiv terapi", path: "/metakognitiv-terapi" },
      { label: "Hypnose", path: "/hypnose" },
      { 
        label: "Angst", 
        path: "/angst",
        dropdown: [
          { label: "Panikangst", path: "/panikangst" },
          { label: "Generaliseret angst", path: "/generaliseret-angst" },
          { label: "Social angst", path: "/social-angst" },
          { label: "Helbredsangst", path: "/helbredsangst" },
          { label: "Eksamensangst & præstationsangst", path: "/eksamensangst-praestationsangst" },
          { label: "Flyskræk", path: "/flyskraek/" },
        ]
      },
      { label: "Stress", path: "/stress" },
      { label: "Depression", path: "/depression" },
      { label: "OCD", path: "/ocd" },
      { label: "ADHD", path: "/adhd" },
      { label: "Autisme", path: "/autismevenlig-terapi" },
      { label: "Borderline", path: "/borderline" },
      { label: "Traume", path: "/traume" },
      { label: "Sorg og tab", path: "/sorg-og-tab" },
      { label: "Søvnproblemer", path: "/soevnproblemer" },
      { label: "Tankemylder", path: "/tankemylder" },
      { label: "Rygestop", path: "/behandlinger/rygestop" },
      { label: "Parterapi & relationscoaching", path: "/parterapi" },
    ]
  },
  { label: "Online sessioner", path: "/online-sessioner" },
  { 
    label: "Om Lars", 
    path: "/om-lars",
    dropdown: [
      { label: "Se hvordan jeg arbejder", path: "/om-lars/se-hvordan-jeg-arbejder" },
    ]
  },
  { label: "Priser", path: "/priser" },
  { label: "FAQ", path: "/faq" },
  { label: "Kontakt", path: "/kontakt" },
  { label: "Book tid", path: "/bestil-tid", primary: true }
];

export const homeContent = {
  hero: {
    title: "Hypnose og metakognitiv terapi mod angst, stress og depression i Valby",
    subtitle: "Her får du hjælp, der virker.",
    description: "Med enkle metoder genvinder du ro, overskud og retning i livet – ofte allerede fra første session."
  },
  testimonials: [
    {
      name: "Jacko Hansen",
      text: "Jeg har været i behandling hos Lars og jeg har stadig stor gavn af behandlingen. Jeg kan få mig selv i hypnose/trance på under 1 minut med en simpel øvelse han har lært mig og det får mit system helt ned.",
      stars: 5
    },
    {
      name: "Ulla Mikkelsen",
      text: "Jeg startede hos Lars pga. en skilsmisse og voldsom angst. Efter et forløb har jeg fået det så meget bedre. Jeg er blevet så meget klogere på den mekanisme der fastholder angsten.",
      stars: 5
    },
    {
      name: "Henriette Knudsen",
      text: "Psykologen kunne ikke hjælpe mig, så jeg fandt Lars på Google. Efter et forløb er jeg nu kommet dertil, at mit overskud og energi er kommet tilbage og jeg er blevet glad igen.",
      stars: 5
    },
    {
      name: "Louise",
      text: "Lars har lært mig at holde afstand til grublerier og bekymringer. Hvad der før fyldte det meste af min dag, fylder i dag ingenting. Jeg kan næsten ikke få armene ned over det gode resultat.",
      stars: 5
    }
  ],
  aboutPreview: {
    quote: "Mit navn er Lars, og jeg hjælper mennesker, der er kørt fast i tankemylder, uro og selvkritik, og som længes efter ro. Jeg bruger metakognitiv terapi og hypnose til at gøre det enkelt igen.",
    description: "Hos Core Hypnose møder du respekt, nærvær og faglighed – og du får fra første session både indsigt og effektive værktøjer, så du kan skabe den forandring, du længes efter."
  },
  sections: [
    {
      title: "Jeg hjælper dig med at finde ro, overskud og retning – uanset om du kæmper med:",
      items: [
        {
          title: "Angst og uro",
          description: "Slip fri af bekymringer og fysisk ubehag med effektive teknikker."
        },
        {
          title: "Stress og udmattelse",
          description: "Genvind dit overskud og lær at håndtere presset i hverdagen."
        },
        {
          title: "Søvnproblemer og tankemylder",
          description: "Få ro i tankerne og genfind den naturlige nattesøvn med enkle redskaber."
        },
        {
          title: "Depression og lavt selvværd",
          description: "Bryd den negative spiral og få glæden og troen på dig selv tilbage."
        },
        {
          title: "OCD og tvangstanker",
          description: "Få kontrol over de mønstre og ritualer, der begrænser din hverdag."
        },
        {
          title: "Traumer og PTSD",
          description: "Bearbejd svære oplevelser og find ro i dit nervesystem igen."
        }
      ]
    }
  ]
};

export const treatmentCategories = [
  {
    title: "Angst & Fobier",
    icon: "Shield",
    description: "Slip fri af bekymringer, panik og fastlåste tankemønstre.",
    items: [
      { label: "Angst (Oversigt)", path: "/angst" },
      { label: "Panikangst", path: "/panikangst" },
      { label: "Generaliseret angst", path: "/generaliseret-angst" },
      { label: "Social angst", path: "/social-angst" },
      { label: "Helbredsangst", path: "/helbredsangst" },
      { label: "Eksamensangst & præstationsangst", path: "/eksamensangst-praestationsangst" },
      { label: "Flyskræk", path: "/flyskraek/" },
      { label: "OCD & Tvangstanker", path: "/ocd" }
    ]
  },
  {
    title: "Stress & Belastning",
    icon: "Leaf",
    description: "Genvind dit overskud, find roen og få din nattesøvn tilbage.",
    items: [
      { label: "Stress", path: "/stress" },
      { label: "Søvnproblemer", path: "/soevnproblemer" },
      { label: "Tankemylder", path: "/tankemylder" }
    ]
  },
  {
    title: "Andre områder",
    icon: "Compass",
    description: "Få støtte til svære livsomstændigheder og mentale udfordringer.",
    items: [
      { label: "Depression", path: "/depression" },
      { label: "Sorg og tab", path: "/sorg-og-tab" },
      { label: "ADHD", path: "/adhd" },
      { label: "Autisme", path: "/autismevenlig-terapi" },
      { label: "Borderline", path: "/borderline" },
      { label: "Traume & PTSD", path: "/traume" }
    ]
  },
  {
    title: "Behandlingsformer",
    icon: "Sparkles",
    description: "Målrettede og effektive metoder til dybdegående forandring.",
    items: [
      { label: "Metakognitiv terapi", path: "/metakognitiv-terapi" },
      { label: "Hypnose & Hypnoterapi", path: "/hypnose" },
      { label: "Rygestop", path: "/behandlinger/rygestop" },
      { label: "Parterapi & relationscoaching", path: "/parterapi" }
    ]
  }
];
